import { mergeDeepRight } from 'ramda';
import RootComponent from './components/RootComponent';
import { AppContainer } from 'react-hot-loader';
import reducer from './reducers';
import ReactDOM from '@hot-loader/react-dom';
import { configureStore } from '../global/utils';
import { initialState as loginInitialState } from './reducers/login';

const initialState = mergeDeepRight({ login: loginInitialState }, window.__LOGIN_INITIAL_STATE__);
const store = configureStore(reducer, initialState);
const rootElement = document.getElementById('ReactLoginPage');

if (process.env.NODE_ENV !== 'production') {
  window.store = store;
}

ReactDOM.render(
  <AppContainer>
    <RootComponent store={store} />
  </AppContainer>,
  rootElement
);

if (module.hot) {
  module.hot.accept('./components/RootComponent', () => {
    const NextRootComponent = require('./components/RootComponent').default;
    ReactDOM.render(
      <AppContainer>
        <NextRootComponent store={store} />
      </AppContainer>,
      rootElement
    );
  });
}
